import * as React from 'react';
import { cn } from '../../lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type}
      className={cn(
        'flex h-11 w-full rounded-2xl bg-white/80 dark:bg-white/[0.04] backdrop-blur-md px-4 py-2 ' +
          'text-[14px] text-ink dark:text-white shadow-pill dark:shadow-none ring-1 ring-ink/8 dark:ring-white/10 ' +
          'placeholder:text-ink/40 dark:placeholder:text-white/40 ' +
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-coral/40 ' +
          'transition-all duration-150 ' +
          'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      ref={ref}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
